export const IMAGES_PATH: ImagesPathInterface = {
  banners: {
    ikea: {
      img: 'assets/pay-club/pics/banners/img/ikea.svg',
      bg: 'assets/pay-club/pics/banners/bg/ikea.svg',
    },
    tapsi: {
      img: 'assets/pay-club/pics/banners/img/tapsi.svg',
      bg: 'assets/pay-club/pics/banners/bg/tapsi.svg',
    },
    khanomi: {
      img: 'assets/pay-club/pics/banners/img/khanomi.svg',
      bg: 'assets/pay-club/pics/banners/bg/khanomi.svg',
    },
    quizofkings: {
      img: 'assets/pay-club/pics/banners/img/quizofkings.svg',
      bg: 'assets/pay-club/pics/banners/bg/quizofkings.svg',
    },
    digiplus: {
      img: '',
      bg: '',
    },
    fidibo: {
      img: '',
      bg: '',
    },
    jabama: {
      img: '',
      bg: '',
    },
    jet: {
      img: 'assets/pay-club/pics/banners/img/Jet.svg',
      bg: 'assets/pay-club/pics/banners/bg/Jet.svg',
    },
    sibapp: {
      img: '',
      bg: '',
    },
    takhfifan: {
      img: '',
      bg: '',
    },
    alopeyk: {
      img: 'assets/pay-club/pics/banners/img/Alopeyk.svg',
      bg: 'assets/pay-club/pics/banners/bg/Alopeyk.svg',
    },
    faradars: {
      img: 'assets/pay-club/pics/banners/img/faradars.svg',
      bg: 'assets/pay-club/pics/banners/bg/Faradars.svg',
    },
    namava: {
      img: 'assets/pay-club/pics/banners/img/Namava.svg',
      bg: 'assets/pay-club/pics/banners/bg/Namava.svg',
    },
    shila: {
      img: 'assets/pay-club/pics/banners/img/Shila.svg',
      bg: 'assets/pay-club/pics/banners/bg/Shila.svg',
    },
    flighto: {
      img: 'assets/pay-club/pics/banners/img/Flighto.svg',
      bg: 'assets/pay-club/pics/banners/bg/Flighto.svg',
    },
    oteacher: {
      img: 'assets/pay-club/pics/banners/img/O-Teacher.svg',
      bg: 'assets/pay-club/pics/banners/bg/O-Teacher.svg',
    },
    bitycle: {
      img: 'assets/pay-club/pics/banners/img/Bitycle.svg',
      bg: 'assets/pay-club/pics/banners/bg/Bitycle.png',
    },
    cinematicket: {
      img: 'assets/pay-club/pics/banners/img/cinematicket.png',
      bg: 'assets/pay-club/pics/banners/bg/cinematicket.svg',
    },
    ekipa: {
      img: 'assets/pay-club/pics/banners/img/ekipa-logo.svg',
      bg: 'assets/pay-club/pics/banners/bg/ekipa-bg.svg',
    },
    // lotteries
    mobile: {
      img: 'assets/pay-club/pics/banners/img/Mobile.svg',
      bg: 'assets/pay-club/pics/banners/bg/Mobile.svg',
    },
    iphone13: {
      img: 'assets/pay-club/pics/banners/img/iphone13.png',
      bg: 'assets/pay-club/pics/banners/bg/iphone13.svg',
    },
    ps5: {
      img: 'assets/pay-club/pics/banners/img/ps5.svg',
      bg: 'assets/pay-club/pics/banners/bg/ps5.svg',
    },
    wallet: {
      img: 'assets/pay-club/pics/banners/img/wallet.png',
      bg: 'assets/pay-club/pics/banners/bg/wallet.svg',
    },
  },
  logos: {
    // vouchers
    digiplus: 'assets/pay-club/pics/logos/Digi-plus.svg',
    fidibo: 'assets/pay-club/pics/logos/Fidibo.svg',
    jabama: 'assets/pay-club/pics/logos/Jabama.svg',
    jet: 'assets/pay-club/pics/logos/Jet.svg',
    sibapp: 'assets/pay-club/pics/logos/Sib-app.svg',
    takhfifan: 'assets/pay-club/pics/logos/Takhfifan.svg',
    alopeyk: 'assets/pay-club/pics/logos/Alopeyk.svg',
    faradars: 'assets/pay-club/pics/logos/Faradars.svg',
    namava: 'assets/pay-club/pics/logos/Namava.svg',
    shila: 'assets/pay-club/pics/logos/Shila.svg',
    flighto: 'assets/pay-club/pics/logos/Flighto.svg',
    oteacher: 'assets/pay-club/pics/logos/O-Teacher.svg',
    bitycle: 'assets/pay-club/pics/logos/Bitycle.png',
    tapsi: 'assets/pay-club/pics/logos/tapsi.png',
    khanomi: 'assets/pay-club/pics/logos/khanomi.png',
    quizofkings: 'assets/pay-club/pics/logos/quizofkings.png',
    ikea: 'assets/pay-club/pics/logos/ikea.svg',
    cinematicket: 'assets/pay-club/pics/logos/cinematicket.svg',
    ekipa: 'assets/pay-club/pics/logos/ekipa-logo.png',
  },
  scoring: {
    'referal-thumbnail': 'assets/pay-club/score-points/invite.svg',
    'miniapp-topup': 'assets/pay-club/score-points/top-up.svg',
    'miniapp-internet-package': 'assets/pay-club/score-points/internet.svg',
    'miniapp-utility-bill': 'assets/pay-club/score-points/bill.svg',
    'miniapp-c2c': 'assets/pay-club/score-points/c2c.svg',
    'festival-campaign-add-car': 'assets/pay-club/score-points/add-dest-card.svg',
    'festival-campaign-add-plate': 'assets/pay-club/score-points/add-plate.svg',
    'miniapp-charity': 'assets/pay-club/score-points/donation.svg',
    'miniapp-toll': 'assets/pay-club/score-points/toll.svg',
    'festival-campaign-complete-profile': 'assets/pay-club/score-points/fill-profile.svg',
    'miniapp-driving-fine': 'assets/pay-club/score-points/pay-fine.svg',
    'add-card': 'assets/pay-club/score-points/add-src-card.svg',
    'first-login': 'assets/pay-club/score-points/first-login.svg',
    'inquiry-fine': 'assets/pay-club/score-points/inquiry-fine.svg',
    'cash-in': 'assets/pay-club/score-points/cash-in.svg',
    'miniapp-credit': 'assets/pay-club/score-points/credit.svg',
    'miniapp-bill-mobile': 'assets/pay-club/score-points/mobile.svg',
    bnpl: 'assets/pay-club/score-points/bnpl.svg',
    'credit-installment': 'assets/pay-club/score-points/credit-installment.svg',
    'bnpl-installment': 'assets/pay-club/score-points/bnpl-installment.svg',
  },
};

// Define the structure for individual banners (with img and bg properties)
interface Banner {
  img: string;
  bg: string;
}

// Define the structure for the logos (with known keys)
interface Logos {
  [key: string]: string;
}

// Define the structure for scoring images (with known keys)
interface Scoring {
  [key: string]: string;
}

// Define the structure for the banners with dynamic keys
interface Banners {
  [key: string]: Banner;
}

// Define the structure for the main IMAGES_PATH object
export interface ImagesPathInterface {
  banners: Banners;
  logos: Logos;
  scoring: Scoring;
}
